"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MONTH_NAMES = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _dayzed = require("dayzed");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _reactLoadingSkeleton = _interopRequireDefault(require("react-loading-skeleton"));
var _HBClickable = _interopRequireDefault(require("../HBClickable/HBClickable"));
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _ArrowLeft = _interopRequireDefault(require("@honeybook/icons/dist/icons/ArrowLeft16"));
var _ArrowRight = _interopRequireDefault(require("@honeybook/icons/dist/icons/ArrowRight16"));
var _DayButton = _interopRequireDefault(require("./DayButton"));
var _color = require("../../utils/color.utils");
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _useFocusGroup = _interopRequireDefault(require("../common/useFocusGroup"));
var _excluded = ["disabled"],
  _excluded2 = ["disabled"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
// TODO: what about i18n? since we don't use react-i18n in HBUI, we'll probably need to propify these.
var WEEKDAY_NAMES_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
var MONTH_NAMES = exports.MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
var HBDayPicker = function HBDayPicker(_ref) {
  var _calendars$, _calendars$2;
  var selectedDate = _ref.selectedDate,
    onDateSelected = _ref.onDateSelected,
    isDisabled = _ref.isDisabled,
    fontFamily = _ref.fontFamily,
    _ref$firstDayOfWeek = _ref.firstDayOfWeek,
    firstDayOfWeek = _ref$firstDayOfWeek === void 0 ? 0 : _ref$firstDayOfWeek,
    _ref$baseTextColor = _ref.baseTextColor,
    baseTextColor = _ref$baseTextColor === void 0 ? _colors["default"].black : _ref$baseTextColor,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? _colors["default"].neutral900 : _ref$backgroundColor,
    _ref$selectedTextColo = _ref.selectedTextColor,
    selectedTextColor = _ref$selectedTextColo === void 0 ? _colors["default"].white : _ref$selectedTextColo,
    _ref$isDateSelectable = _ref.isDateSelectable,
    isDateSelectable = _ref$isDateSelectable === void 0 ? Boolean : _ref$isDateSelectable,
    onMonthChange = _ref.onMonthChange,
    minDate = _ref.minDate,
    isLoading = _ref.isLoading,
    isFetchingMonth = _ref.isFetchingMonth,
    startDate = _ref.startDate;
  var _useDayzed = (0, _dayzed.useDayzed)({
      date: startDate,
      selected: selectedDate,
      onDateSelected: onDateSelected,
      firstDayOfWeek: firstDayOfWeek,
      minDate: minDate
    }),
    calendars = _useDayzed.calendars,
    getBackProps = _useDayzed.getBackProps,
    getForwardProps = _useDayzed.getForwardProps,
    getDateProps = _useDayzed.getDateProps;
  var relevantCalendar = (0, _react.useMemo)(function () {
    return calendars && calendars.length && calendars[0];
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [calendars === null || calendars === void 0 || (_calendars$ = calendars[0]) === null || _calendars$ === void 0 ? void 0 : _calendars$.month, calendars === null || calendars === void 0 || (_calendars$2 = calendars[0]) === null || _calendars$2 === void 0 ? void 0 : _calendars$2.year]);
  var rotatedWeekdayNamesShort = (0, _react.useMemo)(function () {
    return WEEKDAY_NAMES_SHORT.slice(firstDayOfWeek).concat(WEEKDAY_NAMES_SHORT.slice(0, firstDayOfWeek));
  }, [firstDayOfWeek]);
  (0, _react.useEffect)(function () {
    if (!!relevantCalendar) {
      onMonthChange === null || onMonthChange === void 0 || onMonthChange({
        month: relevantCalendar.month,
        year: relevantCalendar.year
      });
    }
  }, [relevantCalendar, onMonthChange]);
  (0, _useFocusGroup["default"])("".concat(ArrowsWrapper, " ").concat(ArrowButton));
  (0, _useFocusGroup["default"])("".concat(Container, " ").concat(StyledDayButton));
  if (!calendars.length) {
    return null;
  }
  var _calendars$3 = calendars[0],
    month = _calendars$3.month,
    year = _calendars$3.year,
    weeks = _calendars$3.weeks;
  var _isDisabled = isDisabled || isLoading;
  var getDayProps = function getDayProps(dateObj) {
    if (dateObj) {
      var _getDateProps = getDateProps({
          dateObj: dateObj
        }),
        disabled = _getDateProps.disabled,
        props = (0, _objectWithoutProperties2["default"])(_getDateProps, _excluded);
      return props;
    }
  };
  var testId = 'hb-day-picker';
  var renderArrow = function renderArrow(isBack) {
    var _ref2 = isBack ? [getBackProps, _ArrowLeft["default"]] : [getForwardProps, _ArrowRight["default"]],
      _ref3 = (0, _slicedToArray2["default"])(_ref2, 2),
      getProps = _ref3[0],
      Arrow16 = _ref3[1];
    var _getProps = getProps({
        calendars: calendars
      }),
      disabled = _getProps.disabled,
      props = (0, _objectWithoutProperties2["default"])(_getProps, _excluded2);
    var __isDisabled = _isDisabled || disabled;
    var directionText = isBack ? 'back' : 'forward';
    return /*#__PURE__*/_react["default"].createElement(ArrowButton, (0, _extends2["default"])({
      onClick: function onClick() {},
      isDisabled: __isDisabled,
      color: baseTextColor,
      testId: "".concat(testId, "-").concat(directionText, "--button")
    }, props), isLoading ? /*#__PURE__*/_react["default"].createElement(_reactLoadingSkeleton["default"], {
      width: 16,
      height: 16
    }) : /*#__PURE__*/_react["default"].createElement(Arrow16, null));
  };
  return /*#__PURE__*/_react["default"].createElement(Container, {
    fontFamily: fontFamily,
    textColor: baseTextColor,
    isDisabled: _isDisabled,
    "data-testid": "".concat(testId, "--wrapper")
  }, /*#__PURE__*/_react["default"].createElement(MonthYear, {
    type: "emphasis16",
    testId: "HBDayPicker-header"
  }, isLoading ? /*#__PURE__*/_react["default"].createElement(_reactLoadingSkeleton["default"], {
    width: 140
  }) : "".concat(MONTH_NAMES[month], " ").concat(year)), /*#__PURE__*/_react["default"].createElement(ArrowsWrapper, null, renderArrow(true), renderArrow(false)), rotatedWeekdayNamesShort.map(function (weekday) {
    return /*#__PURE__*/_react["default"].createElement(WeekDayName, {
      type: "emphasis12",
      key: weekday,
      testId: "HBDayPicker-weekday-".concat(weekday)
    }, isLoading ? /*#__PURE__*/_react["default"].createElement(_reactLoadingSkeleton["default"], {
      width: 24
    }) : weekday);
  }), weeks.flat().map(function (dateObj, dayIndex) {
    return /*#__PURE__*/_react["default"].createElement(StyledDayButton, {
      key: "".concat(month).concat(dayIndex),
      dayzedDateObject: dateObj,
      dayzedDateProps: getDayProps(dateObj),
      isDisabled: _isDisabled,
      isLoading: isLoading || isFetchingMonth,
      backgroundColor: backgroundColor,
      baseTextColor: baseTextColor,
      selectedTextColor: selectedTextColor,
      isDateSelectable: isDateSelectable
    });
  }));
};
var _default = exports["default"] = HBDayPicker; // --- Styles ---
var Container = _styledComponents["default"].div.withConfig({
  displayName: "HBDayPicker__Container",
  componentId: "sc-4jl7q7-0"
})(["color:", ";", ";user-select:", ";max-width:280px;height:fit-content;display:grid;grid-template-rows:repeat(2,auto) repeat(6,1fr);grid-template-columns:repeat(7,1fr);"], function (_ref4) {
  var textColor = _ref4.textColor;
  return textColor || _colors["default"].black;
}, function (_ref5) {
  var fontFamily = _ref5.fontFamily;
  return fontFamily && (0, _styledComponents.css)(["&,*{font-family:", ";}"], fontFamily);
}, function (_ref6) {
  var isDisabled = _ref6.isDisabled;
  return isDisabled ? 'none' : 'initial';
});
var MonthYear = (0, _styledComponents["default"])(_HBText["default"]).withConfig({
  displayName: "HBDayPicker__MonthYear",
  componentId: "sc-4jl7q7-1"
})(["grid-column:span 5;"]);
var ArrowsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBDayPicker__ArrowsWrapper",
  componentId: "sc-4jl7q7-2"
})(["grid-column:span 2;justify-self:end;display:flex;position:relative;right:-10px;top:-6px;"]);
var ArrowButton = (0, _styledComponents["default"])(_HBClickable["default"]).withConfig({
  displayName: "HBDayPicker__ArrowButton",
  componentId: "sc-4jl7q7-3"
})(["display:flex;align-items:center;justify-content:center;height:32px;width:36px;i{line-height:0px;}", ""], function (_ref7) {
  var isDisabled = _ref7.isDisabled,
    color = _ref7.color;
  return isDisabled ? (0, _styledComponents.css)(["svg *{fill:", ";}"], (0, _color.applyOpacity)(color, 20)) : (0, _styledComponents.css)(["svg *{fill:", ";}&:hover,&:focus-visible{svg *{fill:", ";}}"], (0, _color.applyOpacity)(color, 60), color);
});
var WeekDayName = (0, _styledComponents["default"])(_HBText["default"]).withConfig({
  displayName: "HBDayPicker__WeekDayName",
  componentId: "sc-4jl7q7-4"
})(["justify-self:center;margin-bottom:12px;"]);
var StyledDayButton = (0, _styledComponents["default"])(_DayButton["default"]).withConfig({
  displayName: "HBDayPicker__StyledDayButton",
  componentId: "sc-4jl7q7-5"
})(["margin:2px;"]);
//# sourceMappingURL=HBDayPicker.js.map